import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.427 3.331a5.33 5.33 0 0 1 6.363.914L13.653 6h-2.32a.667.667 0 1 0 0 1.333h3.989a.67.67 0 0 0 .452-.166.67.67 0 0 0 .226-.5v-4a.667.667 0 0 0-1.333 0v2.456L12.71 3.282a6.667 6.667 0 1 0 1.578 6.94.667.667 0 1 0-1.258-.444 5.333 5.333 0 1 1-7.604-6.447"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })